import { getWebsocketService } from '~/services/WebSocketService';
import { useWebToken } from './use-websocket-token';

const useWsService = () => {
  const fetchToken = useWebToken();
  return getWebsocketService(fetchToken);
};

export default useWsService;
